<template>
    <div class="modal modal-order-detail">
        <div class="wrapper">
            <div class="overlay_modal"></div>
            <div class="modal_ctn">
                <div class="modal_cerrar" @click="close">
                    <div class="mdi mdi-close"></div>
                </div>
                <h3>PEDIDO Nº {{order.id}}</h3>
                <div class="modal_scroll">
                    <div class="pdatos_row">
                        <div class="pdatos_col">
                            <h4>Cliente</h4>
                            <p><b>Cliente:</b> {{order.clientFullName}}</p>
                            <p><b>Doc. Identidad:</b> {{order.clientIdCard}}</p>
                            <p v-show="!showErpForm"><b>ERP Id:</b> {{order.clientErpId}} <a href="javascript:void(0)"
                                                                                             @click="onShowErpForm"
                                                                                             class="mdi mdi-pencil"></a>
                            </p>
                            <div v-show="showErpForm">
                                <c-input type="text" id="l_erpId" :field="$v.erpId"
                                         classes="mdi mdi-lock-outline inline-input" length="20" placeholder="ERP Id"/>
                                <button class="btn" @click="onSaveErpForm">Actualizar</button>
                            </div>
                            <p v-if="order.clientReference"><b>Referencia:</b> {{order.clientReference}}</p>
                            <p><b>Correo:</b> {{order.clientEmail}}</p>
                            <p><b>Celular:</b> {{order.deliveryPhone}}</p>
                        </div>
                        <div class="pdatos_col">
                            <h4>Envío</h4>
                            <p><b>Tipo de dirección:</b> {{order.deliveryAddressType}} </p>
                            <p><b>Distrito:</b> {{order.deliveryDistrict}}</p>
                            <p><b>Dirección:</b> {{order.deliveryAddress}}</p>
                            <p><b>Número / Lote:</b> {{order.deliveryNumber}}</p>
                            <p><b>Departamento / Interior:</b> {{order.deliveryDeptInt}}</p>
                            <p><b>Urbanización:</b> {{order.deliveryUrbanization}}</p>
                            <p><b>Referencia:</b> {{order.deliveryReference}}</p>
                            <p><b>Confirmó dirección:</b> {{order.deliveryPinAddress ? 'Sí': 'No'}} </p>
                            <p><b>Lat., Long.:</b> {{order.deliveryLat}},{{order.deliveryLng}}</p>

                        </div>
                        <div class="pdatos_col">
                            <h4>Facturación y pago</h4>
                            <p><b>Método de pago:</b> {{getPaymentMethodStr(order.paymentMethod).value}}</p>
                            <p><b>Desea factura:</b> {{order.bill ? 'Sí': 'No'}}</p>
                            <p v-if="order.bill"><b>Razón Social:</b> {{order.billBusiness}}</p>
                            <p v-if="order.bill"><b>R.U.C.:</b> {{order.billIdCard}}</p>
                            <p v-if="order.bill"><b>Dirección:</b> {{order.billAddress}}</p>
                            <p v-if="order.paymentMethod === 3"><b>Banco:</b> {{order.depositBank}}</p>
                            <p v-if="order.paymentMethod === 3"><b>Fecha de depósito:</b> <span
                                v-date-local="order.depositDate"></span></p>
                            <p v-if="order.paymentMethod === 3"><b>Nro. de operación de depósito:</b>
                                {{order.depositTransaction}}</p>
                            <p v-if="order.paymentMethod === 3"><b>Monto de depósito:</b> <span
                                v-pen="order.depositAmount"></span></p>
                            <p><b>Costo de entrega:</b> <span v-if="order.deliveryCost && order.deliveryCost > 0"
                                                              v-pen="order.deliveryCost"></span> <span
                                v-if="!order.deliveryCost">GRATIS</span></p>
                            <p v-if="order.cashAmount"><b>Cancela con:</b> <span v-pen="order.cashAmount"></span></p>
                            <p><b>SubTotal:</b> <span v-pen="order.subtotal"></span></p>
                            <p v-if="order.disc"><b>Dscto. VIP:</b> <span v-pen="order.disc"></span></p>
                            <p><b>Total:</b> <span v-pen="order.total"></span></p>
                        </div>
                    </div>
                    <div class="modal_datos">
                        <div id="map">
                            <GmapMap ref="mapRef"
                                     :options="mapOptions"
                                     :center="{lat:-12.125584, lng: -77.021367}"
                                     :zoom="17"
                                     :initialZoom="true"
                                     style="width: 100%; height: 100%">
                                <GmapMarker
                                    :position="deliveryLatLng"
                                    :clickable="false"
                                    :draggable="false"
                                />
                            </GmapMap>
                        </div>
                    </div>
                    <div class="modal_ctn_scroll">
                        <div class="modal_table">
                            <table>
                                <thead>
                                <tr>
                                    <th>Imagen</th>
                                    <th>descripción</th>
                                    <th>uni</th>
                                    <th>cant.</th>
                                    <th>precio</th>
                                </tr>
                                </thead>
                                <tbody v-if="order && order.items">
                                <tr v-for="i in order.items">
                                    <td><img class="click_img" :src="i.productUrl" alt=""></td>
                                    <td>{{i.productDesc}}</td>
                                    <td v-pen="i.productPrice"></td>
                                    <td>{{i.productQty}} {{i.productUnit}}</td>
                                    <td v-pen="i.subtotal"></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>

    import {paymentMethods} from '../../util/options'
    import CInput from '../common/CInput.vue'
    import {required} from 'vuelidate/lib/validators'
    import OrderService from "../../services/OrderService";
    import {loading} from '../../util/util'

    export default {
        props: ['orderIn'],
        components: {CInput},
        data() {
            return {
                map: null,
                mapOptions: {},
                order: {},
                erpId: null,
                deliveryLatLng: {lat: 0, lng: 0},
                showErpForm: true,
            }
        },
        watch: {
            orderIn: function () {
                const self = this;
                self.order = self.orderIn ? {...self.orderIn} : {};
                self.showErpForm = !self.orderIn.clientErpId;
            },
            order: function () {
                const self = this;
                if (self.order) {
                    if (self.order.deliveryLat && self.order.deliveryLng) {
                        self.deliveryLatLng = {
                            lat: Number(self.order.deliveryLat),
                            lng: Number(self.order.deliveryLng)
                        };
                        const bounds = new google.maps.LatLngBounds();
                        bounds.extend(self.deliveryLatLng);
                        self.map.fitBounds(bounds);
                        self.map.setZoom(18);
                    }
                }
            },
        },
        validations: {
            erpId: {required},
        },
        methods: {
            close() {
                this.erpId = null;
                $(".modal-order-detail").removeClass("active");
            },
            getPaymentMethodStr(payMet) {
                const paymentMethod = paymentMethods.find((s) => s.key === payMet);
                return paymentMethod ? paymentMethod : {};
            },
            onShowErpForm() {
                this.showErpForm = true;
            },
            async onSaveErpForm() {
                const self = this;
                self.$v.$touch();
                if (self.$v.$error) return;
                try {
                    loading(true);
                    const resp = (await OrderService.updateClient(self.order.id, {erpId: self.erpId})).data.payload;
                    self.$emit("updated", resp);
                    self.erpId = null;
                } catch (err) {
                    alert.error(err);
                } finally {
                    loading(false);
                }


            }
        },
        mounted() {
            const self = this;
            self.order = self.orderIn ? {...self.orderIn} : {};
            self.$refs.mapRef.$mapPromise.then((map) => {
                self.map = map;
                self.mapOptions = {
                    mapTypeControl: false,
                    clickableIcons: false,
                    scrollwheel: false,
                    scaleControl: false,
                    zoomControl: false,
                    fullscreenControl: false,
                    streetViewControl: false,
                }
            });

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/orders/OrderDetail.vue